

import {Component, Vue} from "vue-property-decorator"
import config from "@/config";
import type {ICrudOption} from "@/types/m-ui-crud"
import {IPage} from "@/apis/page";
import {checkinPageApi} from "@/apis/linye";

@Component({})
export default class Checkout extends Vue {
  config = config
  // 表格加载状态
  tableLoading: boolean = true;
  // 表格数据
  tableData: any[] = []
  // 表格总数
  tableTotal = 0
  // 查询参数
  queryParam: IPage = {
    page: 1,
    limit: 10
  }
  // 表单参数
  modelForm: Partial<any> = {}
  // crud配置信息
  crudOption: ICrudOption = {
    delBtn: false,
    searchBox: true,
    menu: false,
    dialogWidth: '70%',
    labelWidth: '150px',
    column: [
      {
        label: "ID",
        type: "index",
        prop: "id",
        align: "center",
        width: 50,
        addHide: true,
        editHide: true
      },
      {
        label: "种植园名称",
        prop: "plantationName",
        align: "center",
        placeholder: "请输入种植园名称",
        width: '150px',
        search: true,
        addHide: true,
        editHide: true
      },
      {
        label: "品种名称",
        prop: "fruitTreeName",
        align: "center",
        placeholder: "请输入品种名称",
        search: true,
        addHide: true,
        editHide: true
      },
      {
        label: "来源",
        prop: "source",
        align: "center",
        search: false,
        addHide: true,
        editHide: true
      },
      {
        label: "入库数量（KG）",
        prop: "qty",
        align: "center",
        search: false,
        addHide: true,
        editHide: true
      },
      {
        label: "入库时间",
        prop: "addTime",
        align: "center",
        search: false,
        addHide: true,
        editHide: true
      },
      {
        label: "入库人员",
        prop: "handleBy",
        align: "center",
        placeholder: "请输入入库人员",
        search: true,
        addHide: true,
        editHide: true
      },
      {
        label: "备注",
        prop: "remarks",
        align: "center",
        search: false,
        addHide: true,
        editHide: true
      },
    ]
  }

  getList() {
    this.tableLoading = true
    checkinPageApi(this.queryParam).then(e => {
      this.tableData = e.list
      this.tableTotal = e.total
      this.tableLoading = false
    })
  }

  created() {
    this.getList()
  }
}
